import React, { Component } from 'react';
import cx from 'classnames';
import { Container, List, Segment } from 'semantic-ui-react';
import BEMHelper from 'react-bem-helper';
import PropTypes from 'prop-types';
import { TrackEvent } from '../../Services/TrackEvent';
import SubscriptionPlan from '../Subscription/SubscriptionPlan';

import './Subscription.scss';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { CategoryIcon } from '../Elements/CategoriesIcons';

const bem = BEMHelper({ name: 'SubscriptionPage', outputIsString: true });

const plans = {
  solo: {
    name: 'Solo',
    monthlyPrice: 500,
    annualPrice: 5400,
    annualSaving: 10,
    description: 'The very basic',
    features: [
      'Choose your habits',
      'Plan and Check in',
      'See Your Progress',
      'Build Your Score',
      'Share with buddies',
    ],
    color: 'green',
    monthlyPlanName: 'solo-monthly',
    annualPlanName: 'solo-annual',
    onClickSubscribe: () => TrackEvent('pricing-click-sub-ann-solo'),
    onClickMonthly: () => TrackEvent('pricing-click-sub-monthly-solo'),
  },
  duo: {
    name: 'Duo',
    monthlyPrice: 900,
    annualPrice: 8700,
    annualSaving: 20,
    description: 'Includes Solo and',
    features: [
      'Match with buddies',
      'Find New Buddies',
      'Share Calendars',
      ' Chat/Support',
      'Compare/Compete',
    ],
    color: 'blue',
    monthlyPlanName: 'duo-monthly',
    annualPlanName: 'duo-annual',
    onClickSubscribe: () => TrackEvent('pricing-click-sub-ann-duo'),
    onClickMonthly: () => TrackEvent('pricing-click-sub-monthly-duo'),
  },
  everything: {
    name: 'Everything',
    monthlyPrice: 2499,
    annualPrice: 17988,
    annualSaving: 40,
    description: 'The most comprehensive system for social behavior change.',
    features: [
      'Behavioral Plans',
      'Accountability Buddies',
      'Calendars and Check-ins',
      'Groups & Points',
      'Email & SMS Triggers',
      'Cohort Based Challenges',
    ],
    color: 'orange',
    monthlyPlanName: 'everything-monthly',
    annualPlanName: 'everything-annual',
    recommended: true,
    onClickSubscribe: () => TrackEvent('pricing-click-sub-ann-everything'),
    onClickMonthly: () => TrackEvent('pricing-click-sub-monhtly-everything'),
  },
};

class Subscription extends Component {
  render() {
    const { user, nextQuestion, onChange, extraPadding } = this.props;

    const features = [
      'Take Unlimited Cohort Challenges',
      'Get up to 4 Buddies for Health & Fitness, Work, Learn and Life',
      'Join Groups from your Apps, Work, School or Gym',
      'Import over 400 Behavioral Roadmaps',
      'See Progress through Points',
      'SMS & Email Check ins and Reminders',
    ];

    const plans = user.campaign.subscription_plans;
    return (
      <div className={bem()}>
        {extraPadding && <div style={{ paddingTop: '80px' }} />}
        <h2 style={{ textAlign: 'center' }}>
          {user.campaign.subscription_description}
        </h2>
        <p style={{ textAlign: 'center', fontSize: '18px' }}>
          Select your plan and start your challenge now
        </p>
        <Container>
          <div
            className={cx(
              bem('plans'),
              'flex flex-col md:flex-row justify-center'
            )}
          >
            {plans.map((plan) => (
              <div
                className={bem('plan', [
                  plan.period_unit === 'year' ? 'popular' : '',
                ])}
                key={plan.payment_id}
              >
                <SubscriptionPlan
                  {...plan}
                  campaign_name={user.campaign.name}
                  color={plan.period_unit === 'year' ? 'orange' : 'blue'}
                  user={user}
                  nextQuestion={nextQuestion}
                  assignPlanId={onChange}
                />
              </div>
            ))}
          </div>
        </Container>
        <div
          className={cx(
            bem('students'),
            'flex flex-col md:flex-row justify-center'
          )}
        >
          <a
            style={{ textAlign: 'center' }}
            rel="noopener noreferrer"
            target="_blank"
            className="mt-4"
            href="https://gmb.formaloo.net/q1adu"
          >
            Are you a Student?
          </a>
        </div>
        <Container>
          <div
            className={cx(
              bem('features_title'),
              'flex flex-col md:flex-row justify-center'
            )}
          >
            <p>The most comprehensive system for social behavior change.</p>
          </div>
        </Container>
        <Container>
          <div
            className={cx(
              bem('features'),
              'flex flex-col md:flex-row justify-center'
            )}
          >
            <List>
              {features.map((feature) => (
                <List.Item key={feature}>
                  <List.Icon className={bem('colored')} name="checkmark" />
                  <List.Content>{feature}</List.Content>
                </List.Item>
              ))}
            </List>
          </div>
        </Container>
        <Container>
          <div
            className={cx(
              bem('quote'),
              'flex flex-col md:flex-row justify-center'
            )}
          >
            <i>
              <p>
                "Purchasing a subscription was a no-brainer, as I find my time
                very valuable, and I already was seeing improvements in my
                habits. I would recommend this service to anyone who is looking
                to make their days not only more successful, but also socially
                fulfilling."
              </p>
            </i>
          </div>
          <div
            className={cx(
              bem('separator'),
              'flex flex-col md:flex-row justify-center'
            )}
          >
            <p>
              <strong>_</strong>
            </p>
          </div>
          <div
            className={cx(
              bem('sign'),
              'flex flex-col md:flex-row justify-center'
            )}
          >
            <p>
              <strong>Esther P., Software Engineer</strong>
            </p>
          </div>
        </Container>
      </div>
    );
  }
}

Subscription.propTypes = {
  user: PropTypes.shape({}),
  email: PropTypes.string,
  nextQuestion: PropTypes.func,
  onChange: PropTypes.func,
  extraPadding: PropTypes.bool,
};

const mapStateToProps = (state) => state.signup;

export default withRouter(connect(mapStateToProps, {})(Subscription));
